import {states} from 'brazil-map';

const regionMap:Record<string, string> = {
    "Norte": "AM,RO,RR,AP,PA,TO,AC",
    "Sul": "PR,SC,RS",
    "Sudeste": "SP,RJ,ES,MG",
    "Nordeste": "MA,PI,PB,RN,CE,PE,SE,AL,BA",
    "Centro Oeste": "MT,MS,DF,GO"
}

const stateToRegion = (function(){
    let result:Record<string, string> = {};
    for(var i in regionMap){
        let stateList:string[] = regionMap[i].split(/,/);
        for(var s in stateList){
            result[stateList[s]] = i;
        }
    }
    return result;
})();

export function getRegion(state:string){
    if(state in stateToRegion)
        return stateToRegion[state];
    return "Indefinida";
}

export function stateName(state:string){
    if(state in states)
        return states[state];
    return "Estado";
}

export function isState(a: string){
    return a.toUpperCase() in states
}